import React from 'react';
import {get} from 'lodash';
import moment from 'moment';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import {
  metaLoading,
} from '../lib/helpers';

import OverflowH from './OverflowH';
import DotTooltip from './DotTooltip';
import Loading from './Loading';
import ModalDelete from './ModalDelete';

class ReportToUserList extends React.Component {
  state = {
    ...metaLoading,
    shouldFetch: true,
    reports: []
  }

  fetchData = () => {
    if (this.state.shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/reports`, {
        params: {
          user_id: get(this.props, 'userId'),
          per: 5,
        }
      })
      .then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          this.setState({
            reports: res.data['reports'],
            shouldFetch: false,
            meta: {
              isLoading: false
            },
          })
        }
      })
    }
  }

  componentDidMount() {
    this.setState({
      meta: {
        isLoading: true,
      },
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className='User__header'>
          <h3 className='User__header__h3'>Report to other user list</h3>
        </div>

        <Waypoint onEnter={this.fetchData}>
          <div className='Table__wrapper'>
            <div className='Table Table--user-report-list-1'>
              <div className='Table__row'>
                <div className='Table__col Table__col--th'>ID</div>
                <div className='Table__col Table__col--th'>Report from</div>
                <div className='Table__col Table__col--th'>Report from Birthday (Age)</div>
                <div className='Table__col Table__col--th'>Report to</div>
                <div className='Table__col Table__col--th'>Reason</div>
                <div className='Table__col Table__col--th'>Reported count</div>
                <div className='Table__col Table__col--th'>Blocked count</div>
                <div className='Table__col Table__col--th'>Biography</div>
                <div className='Table__col Table__col--th'>Created date</div>
                <div className='Table__col Table__col--th'>Status</div>
              </div>

              <Loading
                isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'reports.length', 0) == 0}
              >
                {get(this.state, 'reports', []).map((report) => (
                  <div key={report.id} className='Table__row'>
                    <div className='Table__col'>
                      <a
                        className='Table__a'
                        href={`/${gon.currentProvider}/reports/${report.id}`}
                      >
                        {report.id}
                      </a>
                    </div>

                    <div className='Table__col'>
                      <DotTooltip
                        user={report.user}
                      />
                    </div>

                    <div className='Table__col'>
                      {report.user.birthDate &&
                        <span>{moment(report.user.birthDate).format('YYYY-MM-DD')} ({get(report, 'user.age', 'N/A')})</span>
                      }
                    </div>

                    <div className='Table__col'>
                      <DotTooltip
                        user={report.reportable}
                      />
                    </div>

                    <div className='Table__col'>{report.reason}</div>
                    <div className='Table__col'>{get(report, 'reportable.reportedCount', 0)}</div>
                    <div className='Table__col'>{get(report, 'reportable.blockedByCount', 0)}</div>

                    <div className='Table__col'>
                      <OverflowH
                        text={get(report, 'reportable.biography')}
                      />
                    </div>

                    <div
                      className='Table__col'
                      dangerouslySetInnerHTML={
                        {
                          __html: report.createdAt !== null ?
                            moment(report.createdAt).format('YYYY-MM-DD<br />HH:mm')
                          :
                            'N/A'
                        }
                      }
                    />

                    <div className='Table__col'>
                      {report.checkedAt === undefined ?
                        <span className='Badge Badge--gray'>N/A</span>
                      :
                        <React.Fragment>
                          {report.checkedAt !== null ?
                            <span className='Badge'>CHECKED</span>
                          :
                            <span className='Badge Badge--orange'>PENDING</span>
                          }
                        </React.Fragment>
                      }
                    </div>
                  </div>
                ))}
              </Loading>
            </div>

            <a
              className='Table__view-all'
              href={`/${gon.currentProvider}/report/users?user_id=${get(this.props, 'userId')}`}
            >
              View all
            </a>
          </div>
        </Waypoint>
      </React.Fragment>
    );
  }
}

export default ReportToUserList
